define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/action/Controller",
	"csi/comm/PostRequest"
], function(declare,lang,Controller,PostRequest) {

	return declare(Controller, {
		process: function() {
			// summary: issue request so as to be able to receive return value
			var	req = this.m_action.m_request;

			this.setProgress();

			new PostRequest(req.m_module, req.m_operation)
				.addParameter("AddURLs", this.m_formData.getSelectedValue())
				.post({}).then(lang.hitch(this, this._onPublishResponse));
		},

		/**
		 * @override
		 *
		 * Add existing filters from table view
		 */
		onCreatePopup: function(view) {
		    view.copyQuery(this.widget);
		    this.inherited(arguments);
		}
	});
});